/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageTunnelStressAreaDto } from '../../models/page-tunnel-stress-area-dto';

export interface GetTunnelStressAreas$Params {

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;

/**
 * filter string
 */
  filter?: string;

/**
 * Get terser output with fewer fields filled in
 */
  terse?: boolean;
}

export function getTunnelStressAreas(http: HttpClient, rootUrl: string, params?: GetTunnelStressAreas$Params, context?: HttpContext): Observable<StrictHttpResponse<PageTunnelStressAreaDto>> {
  const rb = new RequestBuilder(rootUrl, getTunnelStressAreas.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('filter', params.filter, {});
    rb.query('terse', params.terse, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageTunnelStressAreaDto>;
    })
  );
}

getTunnelStressAreas.PATH = '/v1/tunnelstressarea';
